<template>
	<ui-dialog :title="getTitle" @submit="onSubmit" @close="onClose">
		<ui-text-field label="Namn" v-model="formData.name" :rules="$validator('base/required')"/>

		<template #actions>
			<div class="is-flex is-justify-content-space-between">
				<div class="is-flex is-align-items-center">
					<ui-alert v-if="error" error>{{ error }}</ui-alert>
					<ui-alert v-if="successMessage" success>{{ successMessage }}</ui-alert>
				</div>
				<ui-btn class="is-info" :loading="isPending" type="submit" icon="fa-save">Spara</ui-btn>
			</div>
		</template>
	</ui-dialog>
</template>

<script>
import { mapGetters } from 'vuex';

const initalFormData = () => ({
	name: ''
});

export default {
	props: {
		isEdit: {
			type: Boolean,
			default: false
		},

		isRoot: {
			type: Boolean,
			default: false
		}
	},

	data: () => ({
		formData: initalFormData(),

		error: '',
		successMessage: '',
		isPending: false
	}),

	computed: {
		...mapGetters('user', ['getActiveCustomer', 'getActiveCompany']),

		getTitle() {
			if (this.isRoot) {
				return 'Ny Kund';
			}

			return this.isEdit ? 'Editera Nivå' : 'Ny Nivå';
		}
	},

	created() {
		if (this.isEdit) {
			this.formData = {
				...this.formData,
				name: this.getActiveCustomer.name
			};
		}
	},

	methods: {
		onSubmit() {
			this.error = '';
			this.successMessage = '';

			if (this.isEdit) {
				this.updateCustomer();

				return;
			}

			this.createCustomer();
		},

		async createCustomer() {
			try {
				await this.$services.customer.createCustomer({
					...this.formData,
					parentId: this.isRoot ? null : this.getActiveCustomer.id,
					companyId: this.getActiveCompany.id
				}, {
					throwException: true,
					loading: val => {
						this.isPending = val;
					}
				});

				this.successMessage = this.isRoot ? 'Kunden skapades utan problem' : 'Nivån skapades utan problem.';
				this.formData = initalFormData();

				this.$emit('on-update');
			} catch (error) {
				this.error = error.message;
			}
		},

		async updateCustomer() {
			try {
				await this.$services.customer.update(this.getActiveCustomer.id, {
					...this.formData,
					parentId: this.getActiveCustomer.parentId,
					companyId: this.getActiveCompany.id
				}, {
					throwException: true,
					loading: val => {
						this.isPending = val;
					}
				});

				this.successMessage = 'Nivån uppdaterades utan problem.';

				this.$emit('on-update');
			} catch (error) {
				this.error = error.message;
			}
		},

		onClose() {
			this.$emit('close');
		}
	}
};
</script>
